var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFinplan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "7 7 30 30",
    fill: "none",
    stroke: "#929497",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 16v12M21.273 22C20.017 22 19 21.105 19 20s1.017-2 2.273-2H24M20 26h2.727C23.983 26 25 25.105 25 24s-1.017-2-2.273-2H21.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgFinplan;